import { render, staticRenderFns } from "./HouseholdGasIcon.vue?vue&type=template&id=4f8314ba"
import script from "./HouseholdGasIcon.vue?vue&type=script&lang=js"
export * from "./HouseholdGasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports